export enum Title {
  MR = 'MR',

  MRS = 'MRS',

  DIVERSE = 'DIVERSE',
}
